import {
  GET_ORGANIZATIONS,
  GET_ORGANIZATION_BY_ID,
  GET_ORGANIZATION_DETAILS,
  GET_ORGANIZATION_MEMBERS,
  RESET_ORGANIZATION_DETAILS,
  GET_ORGANIZATION_PAYMENTS,
} from '../actionTypes';

const initialState = {
  organizations: [],
  organizationDetails: null,
  organizationDetailsById: null,
  organizationMembers: [],
  organizationPayments: [],
};

const organizationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORGANIZATIONS:
      return {
        ...state,
        organizations: action.payload,
      };
    case GET_ORGANIZATION_DETAILS:
      return {
        ...state,
        organizationDetails: action.payload,
      };
    case RESET_ORGANIZATION_DETAILS:
      return {
        ...state,
        organizationDetails: null,
      };
    case GET_ORGANIZATION_BY_ID:
      return {
        ...state,
        organizationDetailsById: action.payload,
      };
    case GET_ORGANIZATION_MEMBERS:
      return {
        ...state,
        organizationMembers: action.payload,
      };
    case GET_ORGANIZATION_PAYMENTS:
      return {
        ...state,
        organizationPayments: action.payload,
      };
    default: {
      return state;
    }
  }
};

export default organizationsReducer;
